import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-top-navigation"
}
const _hoisted_2 = { class: "mobile-top-navigation__title" }
const _hoisted_3 = { class: "mobile-menu-content-wrapper" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "title-block" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_9 = {
  key: 1,
  class: "mobile-menu-separator"
}
const _hoisted_10 = {
  key: 2,
  class: "mobile-menu-profile-actions"
}
const _hoisted_11 = {
  key: 0,
  class: "mobile-menu-profile-actions__item"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "mobile-menu-profile-actions__item"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 2,
  class: "mobile-menu-profile-actions__item"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 3,
  class: "mobile-menu-profile-actions__item"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 4,
  class: "mobile-menu-profile-actions__item"
}
const _hoisted_20 = { class: "mobile-menu-profile-actions__item" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 5,
  class: "mobile-menu-profile-actions__item"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 6,
  class: "mobile-menu-profile-actions__item logout"
}
const _hoisted_25 = {
  key: 7,
  class: "mobile-menu-profile-actions__item logout"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "mobile-menu-profile-actions__item header__menu__language-switcher" }
const _hoisted_28 = { class: "popper-menu-wrapper" }
const _hoisted_29 = { class: "language-switcher__text mobile-action-link" }
const _hoisted_30 = { class: "languages-list" }
const _hoisted_31 = ["onClick"]

import MobileMenuToggle from "@/components/menu-blocks/MobileMenuToggle.vue";
  import Search from "@/components/_partials/Search.vue";
  import MessageCounter from "@/components/menu-blocks/MessageCounter.vue";
  import { IMenuItem, ILanguage } from "@/models";
  import { computed, onMounted, reactive } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { trans } from "@/utils/trans";
  import NotificationCounter from "@/components/menu-blocks/NotificationCounter.vue";
  import NotificationsPanel from "@/components/menu-blocks/NotificationsPanel.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenu',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const menuItems = auctionStore.menu;
  const unreadCount = auctionStore.user?.unreadMessageCount;

  const state = reactive({
    activeLevel: null as IMenuItem | null,
    activeLevelSequence: [],
    isOpenNotificationPanel: false
  });

  const bidsLink = computed(() => auctionStore.routes["profile.bids.active"]);
  const purchasesLink = computed(() => auctionStore.routes["profile.invoices.index"]);
  const profileLink = computed(() => auctionStore.routes["profile.info.edit"]);
  const calendarLink = computed(() => auctionStore.routes["site.auctions.show_calendar"]);
  const messagesLink = computed(() => auctionStore.routes["profile.messages.index"]);
  const loginLink = computed(() => auctionStore.routes["login"] + '?redirect=' + location.href);
  const catalogLink = computed(() => auctionStore.routes["site.lots.show_catalog"]);

  const languages = computed(() => auctionStore.languageSettings.languages);
  const language = computed(() => auctionStore.languageSettings.language ?? 'en');

  onMounted(() => {
    getLevelItemsBySequence();
  });

  const clickOnItem = (index: number) => {
    if (state.activeLevel) {
      if (state.activeLevel?.children[index]?.children?.length > 0) {
        state.activeLevel = state.activeLevel?.children[index];
        state.activeLevelSequence.push(index);
      } else {
        window.open(state.activeLevel?.children[index]?.link.url, "_self");
      }
    }
  };

  const backLevel = () => {
    state.activeLevelSequence.pop();
    getLevelItemsBySequence();
  };

  const getLevelItemsBySequence = () => {
    if (state.activeLevelSequence.length === 0) {
      state.activeLevel = { children: menuItems };
    } else {
      let result = menuItems;

      for (let i = 0; i < state.activeLevelSequence.length; i++) {
        result = result[state.activeLevelSequence[i]];
        if (result?.children && i !== state.activeLevelSequence.length - 1) {
          result = result.children;
        }
      }

      state.activeLevel = result;
    }
  };

  const switchLanguage = (language: ILanguage) => {
    apiClient.put(language.url).then((response) => {
      auctionStore.$patch((storeState) => {
        storeState.translations = response.data;
        storeState.languageSettings.language = language.abbr;
        storeState.languageSettings.htmlDirection = language.htmlDirection;
      });
    });
  };

  const closeMenu = () => {
    state.activeLevel = { children: menuItems };
    state.activeLevelSequence = [];
  };

  const openNotificationsPanel = () => {
    state.isOpenNotificationPanel = true;
  };

  const hideNotificationsPanel = () => {
    state.isOpenNotificationPanel = false;
  };

  const logout = () => {
    apiClient.post(auctionStore.routes["logout"]).then(() => {
      window.location.reload();
    });
  };

return (_ctx: any,_cache: any) => {
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['header-mobile-menu', { 'show-top-navigation': state.activeLevelSequence.length > 0 }])
    }, [
      (state.activeLevelSequence.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (state.activeLevelSequence.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "mobile-top-navigation__back",
                  onClick: backLevel
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, _toDisplayString(state.activeLevel?.link?.title), 1),
            _createVNode(MobileMenuToggle, { onCloseMenu: closeMenu })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-menu-list", `level-${state.activeLevelSequence.length + 1}`])
        }, [
          (
            (state.activeLevel?.link?.url && state.activeLevel?.link?.url !== 'javascript:void(0)') ||
            state.activeLevel?.view_all_link === 1
          )
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: state.activeLevel?.view_all_link === 1 ? catalogLink.value : state.activeLevel?.link?.url,
                class: "mobile-menu-list__item"
              }, " All " + _toDisplayString(state.activeLevel.link?.title), 9, _hoisted_4))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.activeLevel?.children || state.activeLevel, (item, index) => {
            return (_openBlock(), _createElementBlock("a", {
              onClick: _withModifiers(($event: any) => (clickOnItem(index)), ["prevent"]),
              key: index,
              class: _normalizeClass(['mobile-menu-list__item', item?.children?.length > 0 ? 'has-children' : 'without-children'])
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(item?.link.title), 1),
                (item?.link?.subtitle)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item?.link.subtitle), 1))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_5))
          }), 128))
        ], 2),
        (state.activeLevelSequence.length === 0)
          ? (_openBlock(), _createBlock(Search, {
              key: 0,
              class: "search-form-mobile"
            }))
          : _createCommentVNode("", true),
        (state.activeLevelSequence.length === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9))
          : _createCommentVNode("", true),
        (state.activeLevelSequence.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("a", {
                      href: bidsLink.value,
                      class: "mobile-action-link"
                    }, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon icon-bids" }, [
                          _createElementVNode("use", { href: "/sprite.svg#bids" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.user_menu.bids")), 1)
                    ], 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true),
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("a", {
                      href: purchasesLink.value,
                      class: "mobile-action-link"
                    }, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon icon-shopping" }, [
                          _createElementVNode("use", { href: "/sprite.svg#shopping" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.user_menu.purchases")), 1)
                    ], 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("a", {
                      href: profileLink.value,
                      class: "mobile-action-link"
                    }, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon icon-user" }, [
                          _createElementVNode("use", { href: "/sprite.svg#user" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.user_menu.profile")), 1)
                    ], 8, _hoisted_16)
                  ]))
                : _createCommentVNode("", true),
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("a", {
                      href: messagesLink.value,
                      class: "mobile-action-link"
                    }, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon icon-message" }, [
                          _createElementVNode("use", { href: "/sprite.svg#mail" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.profile_icons.messages")), 1)
                    ], 8, _hoisted_18),
                    _createVNode(MessageCounter, {
                      class: "mobile-action-counter",
                      "init-count": _unref(unreadCount)
                    }, null, 8, ["init-count"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", {
                      onClick: openNotificationsPanel,
                      class: "mobile-action-link"
                    }, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon icon-bell" }, [
                          _createElementVNode("use", { href: "/sprite.svg#bell" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.profile_icons.notifications")), 1)
                    ]),
                    _createVNode(NotificationCounter, { class: "mobile-action-counter notifications-counter" })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", {
                  href: calendarLink.value,
                  class: "mobile-action-link"
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon-block" }, [
                    _createElementVNode("svg", { class: "icon icon-calendar" }, [
                      _createElementVNode("use", { href: "/sprite.svg#calendar" })
                    ])
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(trans)("header.profile_icons.calendar")), 1)
                ], 8, _hoisted_21)
              ]),
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("a", {
                      href: bidsLink.value,
                      class: "mobile-action-link"
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon-star" }, [
                          _createElementVNode("use", { href: "/sprite.svg#star" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.profile_icons.watching")), 1)
                    ], 8, _hoisted_23)
                  ]))
                : _createCommentVNode("", true),
              (_unref(auctionStore).user?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "mobile-action-link",
                      onClick: _withModifiers(logout, ["prevent"])
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon-logout" }, [
                          _createElementVNode("use", { href: "/sprite.svg#logout" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.user_menu.logout")), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("a", {
                      href: loginLink.value,
                      class: "mobile-action-link"
                    }, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "icon-block" }, [
                        _createElementVNode("svg", { class: "icon-logout" }, [
                          _createElementVNode("use", { href: "/sprite.svg#logout" })
                        ])
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(trans)("header.login")), 1)
                    ], 8, _hoisted_26)
                  ])),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "mobile-menu-separator" }, null, -1)),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_v_menu, {
                  placement: "right",
                  theme: "info-menu-without-arrow",
                  distance: 10,
                  delay: 50
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(language.value?.toUpperCase()), 1)
                    ])
                  ]),
                  _: 2
                }, [
                  (languages.value.length > 0)
                    ? {
                        name: "popper",
                        fn: _withCtx(() => [
                          _createElementVNode("div", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (lang) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (lang.abbr !== language.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: lang.abbr,
                                      class: "languages-list__inner-wrapper"
                                    }, [
                                      _createElementVNode("div", {
                                        class: "languages-list__item",
                                        onClick: ($event: any) => (switchLanguage(lang))
                                      }, _toDisplayString(lang.abbr?.toUpperCase()), 9, _hoisted_31)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(NotificationsPanel, {
      class: _normalizeClass(['mobile-notifications-panel', { hide: !state.isOpenNotificationPanel }]),
      "is-mobile-menu-prop": "",
      onClosePanel: hideNotificationsPanel
    }, null, 8, ["class"])
  ], 64))
}
}

})